import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  ListItem,
  ListItemText,
  Link,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Layout from "../layout/layout";
import {api}from "../services/api";
import ViewInArIcon from '@mui/icons-material/ViewInAr';

import ec2Image from "../assets/Res_Amazon-EC2_Instances_48.svg";
import s3Image from "../assets/Res_Amazon-Simple-Storage-Service_Bucket_48.svg";
import securityHubImage from "../assets/Res_AWS-Security-Hub_Finding_48.svg";
import rdsImage from "../assets/Res_Amazon-Aurora_Amazon-RDS-Instance_48.svg";
import auroraImage from "../assets/Res_Amazon-Aurora-Instance_48.svg";
import efsImage from "../assets/Res_Amazon-Elastic-File-System_EFS-Intelligent-Tiering_48.svg";
import eksImage from "../assets/Res_Amazon-Elastic-Kubernetes-Service_EKS-on-Outposts_48.svg";
import lambdaImage from "../assets/Res_AWS-Lambda_Lambda-Function_48.svg";
import elasticBeanstalkImage from "../assets/Res_AWS-Elastic-Beanstalk_Application_48.svg";
import RouteImage from "../assets/Res_Amazon-Route-53_Readiness-Checks_48.svg";
import albImage from "../assets/Res_Elastic-Load-Balancing_Application-Load-Balancer_48.svg";
import nlbImage from "../assets/Res_Elastic-Load-Balancing_Network-Load-Balancer_48.svg";


const ServicesNew = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [visibleResources, setVisibleResources] = useState({});
  const [loading, setLoading] = useState(true);

  const serviceCatelogue = localStorage.getItem('catalogueSelection');


  useEffect(() => {
    const fetchCategories = async () => {
      const cloudProviderId = localStorage.getItem('selectedProviderId');
      let serviceId = localStorage.getItem('catalogueSelection');
  
      if (serviceId === 'New') {
        serviceId = 1;
      } else if (serviceId === 'Operational') {
        serviceId = 2;
      } else {
        console.error("Unexpected catalogueSelection value:", serviceId);
        return;
      }
  
      setLoading(true);
      try {
        const response = await api.get(
          "/api/Application/popularServices",
          {
            params: {
              cloudProviderId: cloudProviderId,
              serviceId: 1,
              page: 1,
              pageSize: 10,
            }
          }
        );
  
        // Group services by category
        const groupedCategories = response.data.reduce((acc, service) => {
          const category = service.category;
  
          if (!acc[category]) {
            acc[category] = {
              categoryName: category,
              resources: [], // Ensure resources array is initialized
            };
          }
          acc[category].resources.push(service);
  
          return acc;
        }, {});
  
        const initialVisibleResources = Object.keys(groupedCategories).reduce((acc, categoryName) => {
          acc[categoryName] = 5; // Initially show 5 items per category
          return acc;
        }, {});
  
        setCategories(Object.values(groupedCategories));
        setVisibleResources(initialVisibleResources);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCategories();
  }, []);
  
  
  // const handleResourceClick = (resourceId, resourceName) => {
    
  //   navigate("/Resources/View_Resources", { state: { resourceId, resourceName } });
  // };


  const handleResourceClick = (resource) => {
  // Only navigate if the resource is enabled on UI
  if (resource.isEnabledonUI) {
    navigate("/Resources/View_Resources", { 
      state: { 
        resourceId: resource.resourceId, 
        resourceName: resource.resourceName 
      } 
    });
  }
};

  const handleViewMore = (categoryID) => {
    setVisibleResources((prevVisibleResources) => ({
      ...prevVisibleResources,
      [categoryID]: prevVisibleResources[categoryID] + 5,
    }));
  };


//   const getResourceImage = (resourceName) => {
//   const name = resourceName.toLowerCase();
  
//   if (name.includes('ec2') || name.includes('instance')) {
//     return ec2Image;
//   } else if (name.includes('s3') || name.includes('storage') || name.includes('bucket')) {
//     return s3Image;
//   } else if (name.includes('security') || name.includes('hub')) {
//     return securityHubImage;
//   }
  
//   return ec2Image; // Default fallback
// };
const getResourceImage = (resourceName) => {
    const name = resourceName.toLowerCase();
    
    // EC2 and Instances
    if (name.includes('ec2') || name.includes('instance')) {
      return ec2Image;
    }
    // S3 and Storage
    else if (name.includes('s3') || name.includes('storage') || name.includes('bucket')) {
      return s3Image;
    }
    // Security Hub
    else if (name.includes('security') || name.includes('hub')) {
      return securityHubImage;
    }
    // RDS (general database service)
    else if (name.includes('rds') || name.includes('database')) {
      return rdsImage;
    }
    // Aurora (specific database service)
    else if (name.includes('aurora')) {
      return auroraImage;
    }
    // Lambda Functions
    else if (name.includes('lambda') || name.includes('function')) {
      return lambdaImage;
    }
    // Elastic File System
    else if (name.includes('efs') || name.includes('file system') || name.includes('elastic file')) {
      return efsImage;
    }
    // Elastic Kubernetes Service
    else if (name.includes('eks') || name.includes('kubernetes') || name.includes('k8s')) {
      return eksImage;
    }
    // Elastic Beanstalk
    else if (name.includes('beanstalk') || name.includes('elastic beanstalk')) {
      return elasticBeanstalkImage;
    }
    
   // Route 53   
else if (name.includes('route 53') || name.includes('route53') || name.includes('dns')) {
  return RouteImage;
}
//ALB
else if (name.includes('alb') || name.includes('application load balancer')) {
  return albImage;
}
//NLB
else if (name.includes('nlb') || name.includes('network load balancer')) {
  return nlbImage;
}



    // Default fallback
    return ec2Image;
  };


  return (
    <Layout pageType="sideBar">
      <Box
        sx={{
          flex: 1,
          pl: 2,
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        <Typography variant="body2" gutterBottom sx={{ marginTop: "20px", textTransform:'capitalize' }}>
          {serviceCatelogue}  Resource
        </Typography>
        <Divider />
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2} alignItems="stretch">
  {categories.map((category) => (
    <Grid
      item
      
      key={category.categoryName}
      sx={{ display: "flex", flexDirection: "column",width:'32%' }}
    >
      <Paper
        sx={{
          p: 2,
          bgcolor: theme.palette.background.default,
          width: "100%",
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
           maxHeight: "300px"           // Set a fixed height for uniformity
        }}
      >
        <Box
          sx={{
            borderBottom: "2px solid #2b61aa",
            px: 1,
            display: "inline-block",
            mb: 1,
          }}
        >
          {/* <Link
            href="#"
            underline="hover"
            sx={{ color: theme.palette.text.primary, textTransform: 'capitalize' }}
          > */}
            <Typography variant="body2" gutterBottom>
              {category.categoryName}
            </Typography>
          {/* </Link> */}
        </Box>
        <Grid container spacing={1} sx={{ flexDirection: "column", flexGrow: 1 }}>
          {category.resources
            .slice(0, visibleResources[category.categoryName] || 10)
            .map((resource) => (
              <Grid item xs={12} key={resource.resourceId}>

             
                 <ListItem
  onClick={() => handleResourceClick(resource)}
  button={resource.isEnabledonUI}
  sx={{
    cursor: resource.isEnabledonUI ? "pointer" : "not-allowed",
    opacity: resource.isEnabledonUI ? 1 : 0.8,
    padding: "4px 8px",
    display: "flex",
    textTransform: "capitalize",
    fontSize: '12px',
    transition: 'all 0.2s ease',
    // Only apply hover effects if enabled
    ...(resource.isEnabledonUI && {
      '&:hover': {
        bgcolor: '#2b61aa',
        '& .MuiTypography-root': {
          color: 'white !important',
        },
        '& .resource-icon': {
          filter: 'brightness(0) invert(1)',
        }
      }
    }),
    // Style for disabled items
    ...(!resource.isEnabledonUI && {
      '& .MuiTypography-root': {
        color: theme.palette.text.disabled,
      }
    })
  }}
>
  <Box
    component="img"
    src={getResourceImage(resource.resourceName)}
    alt={resource.resourceName}
    className="resource-icon"
    sx={{
      width: 20,
      height: 20,
      mr: 2,
      flexShrink: 0,
      filter: resource.isEnabledonUI ? 'none' : 'grayscale(100%) opacity(0.5)',
      transition: 'filter 0.2s ease',
    }}
  />
  <ListItemText 
    primary={resource.resourceName} 
    sx={{
      '& .MuiTypography-root': {
        fontSize: '12px',
        color: resource.isEnabledonUI ? 'inherit' : theme.palette.text.disabled,
      }
    }} 
  />
</ListItem>




              </Grid>
            ))}
        </Grid>
        {visibleResources[category.categoryName] < category.resources.length && (
          <Button
            onClick={() => handleViewMore(category.categoryName)}
            sx={{ mt: 2, color: "#2b61aa" }}
          >
            View More 
          </Button>
        )}
      </Paper>
    </Grid>
  ))}
</Grid>


        )}
      </Box>
    </Layout>
  );
};

export default ServicesNew;
